import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductService } from "../../../services/product.service";
import { Product } from "../../../classes/product";
import { GoogleAnalyticsService } from '../../../../shared/services/google-analytics.service';

@Component({
  selector: 'app-cart-variation',
  templateUrl: './cart-variation.component.html',
  styleUrls: ['./cart-variation.component.scss']
})
export class CartVariationComponent implements OnInit, OnDestroy {

  @Input() direction: string = 'right'; // Default Direction Right

  public products: Product[] = [];
  public userName: any;

  constructor(public productService: ProductService,
    private analytics: GoogleAnalyticsService) {
    this.productService.cartItems.subscribe(response => this.products = response);
  }

  ngOnInit(): void {
    this.productService.OpenCart = false;
    this.userName = JSON.parse(sessionStorage.getItem("user"))?.userName || 'invitado@GIGMAX.com';
  }

  closeCart() {
    this.productService.OpenCart = false;
  }

  get getTotal(): Observable<number> {
    return this.productService.cartTotalAmount();
  }

  removeItem(product: any) {
    this.productService.removeCartItem(product);
    this.analytics.sendEvent('remove_from_cart', {
      idEvento: 5,
      currency: 'MXN',
      userName: this.userName,
      value: product.price,
      items: [
        {
          item_name: product.title,
          item_id: product.id,
          price: product.price,
          quantity: 1,
        },
      ],
    });
  }

  ngOnDestroy(): void {
    this.closeCart();
  }

}
